import { Product } from '../types';
import { Get } from './helpers/builder';

export const getAllProducts = Get`/product/all`.json<{response: Product[]}>();
